import { computed } from 'vue';
import { includes } from "./../../core/keep-alive/keepAlive";
import { ApprovalFlowService } from "@/components/approval-table-flow-btn/approval-flow.service";
import { message } from "ant-design-vue";
import { BtnService } from "./btn.service";
import {
  FlowBtnVisibleByContract,
  FlowBtnVisibleByIncomeTicket,
  FlowBtnVisibleByMakeTicket,
  FlowBtnVisibleByPayment,
  FlowBtnVisibleByPaymentMoney,
  FlowBtnVisibleByProject,
} from "./flow-btn.constant";

export const useFlowHandle = () => {
  const { run: runSubmit, loading:submitLoading=false  } = ApprovalFlowService.useSubmitApi();
  const { run: runCancel, loading:cancelLoading=false  } = ApprovalFlowService.useCancelApi();
  const { run: runVoid, loading:voidLoading=false } = BtnService.useVoidApi();
  const { run: runAgree, loading:agreeLoading=false  } = ApprovalFlowService.useAgreeApi();
  const { run: runReject, loading:rejectLoading=false  } = ApprovalFlowService.useRejectApi();
  const { run: runDelete, loading:deleteLoading=false  } = BtnService.useDeleteApi();
  const { run: runDeleteComplete, loading:deleteCompleteLoading=false  } = BtnService.useDeleteCompletelyApi();
  const { run: runRecycle, loading:recycleLoading=false  } = BtnService.useRecycleApi();
  const loading=computed(()=>(recycleLoading||deleteCompleteLoading||deleteLoading||rejectLoading||agreeLoading||voidLoading||cancelLoading||submitLoading))
  // 提交审批
  const submitBtn = async (bizId, bizType, bizName) => {
    let res = await runSubmit({ bizId, bizType, bizName });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };

  //撤销
  const cancelBtn = async (bizId, bizType) => {
    let res = await runCancel({ bizId, bizType });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };

  // 作废
  const voidBtn = async (bizId, bizType, bizName, approvalContent,isOldVoid) => {
    let res = await runVoid({ bizId, bizType, cancelDesc: approvalContent ,bizName,oldCancelFlag:Number(isOldVoid),remark: approvalContent});
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };

  //同意
  const agreeBtn = async (bizId, bizType, bizName, approvalContent) => {
    let res = await runAgree({ bizId, bizType, bizName, remark: approvalContent });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };

  //拒绝
  const rejectBtn = async (bizId, bizType, bizName, approvalContent) => {
    let res = await runReject({ bizId, bizType, bizName, remark: approvalContent });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };
  //删除
  const deleteBtn = async (bizId, bizType, approvalContent) => {
    let res = await runDelete(bizId, { bizType, recycleDesc: approvalContent });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };
  //彻底删除
  const deleteCompleteBtn = async (bizIds, bizType) => {
    let res = await runDeleteComplete({ bizType, bizIds });
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };
  //恢复useRecycleApi
  const recycleBtn = async (bizId, bizType) => {
    let res = await runRecycle(bizId, bizType);
    if (res.respCode !== "0000") {
      // message.error(res.respDesc);
      return;
    }
    message.success(res.respDesc);
  };
  // 特殊业务状态下按钮处理

  const visibleBtnByStatus = (bizType, statuValue,other?,row?) => {
    //项目状态==已关闭
    if ((FlowBtnVisibleByProject.includes(bizType)&& (statuValue == "ygb"))) {
      return false;
    }
    //合同状态==已终止
    if ((FlowBtnVisibleByContract.includes(bizType)&&(statuValue == "yzz"))) {
      return false;
    } 
    //应收款状态==取消收款
    if ((FlowBtnVisibleByPayment.includes(bizType)&&(statuValue == "qxsk"||statuValue =='wcsk'))) {
      return false;
    } 
    //应付款状态==取消付款
    if ((FlowBtnVisibleByPaymentMoney.includes(bizType)&& (statuValue == "qxfk"||statuValue == "wcfk"))) {
      return false;
    }
     //开票状态==取消开票
     if ((FlowBtnVisibleByMakeTicket.includes(bizType)&&(statuValue == "qxkp"||statuValue =='wckp'))) {
      return false;
    }
     //收票状态==取消收票
     if ((FlowBtnVisibleByIncomeTicket.includes(bizType)&& (statuValue == "qxsp"||statuValue == "wcsp"))) {
      return false;
    }
    if(other&&(typeof other=="function")){
      return other(row)
    }
    return true;
  };
  return {
    submitBtn,
    cancelBtn,
    voidBtn,
    agreeBtn,
    rejectBtn,
    deleteBtn,
    deleteCompleteBtn,
    visibleBtnByStatus,
    recycleBtn,loading
  };
};
